<template>
  <v-dialog :value="value" max-width="1120" scrollable persistent @input="fechar">
    <v-card class="criterio5-modal">
      <v-toolbar color="azulclarosc" dark dense>
        <v-toolbar-title>Critério 05 · Capacitação das equipes</v-toolbar-title>
        <v-spacer />
        <v-btn icon aria-label="Fechar avaliação" @click="fechar"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text v-if="dados && dados.legada" class="criterio5-conteudo">
        <v-alert type="info" outlined class="mt-4">{{ dados.resumoFinal }}</v-alert>
        <p><strong>Pontuação registrada:</strong> {{ dados.pontos == null ? 'Sem faixa registrada' : dados.pontos.toLocaleString('pt-BR') + ' pontos' }}</p>
        <div v-for="arquivo in dados.arquivos" :key="arquivo.perguntaEvidenciaId" class="criterio5-arquivo">
          <div class="criterio5-linha">
            <span class="criterio5-nome">{{ arquivo.nomeArquivo }}</span>
            <v-btn small text color="primary" :loading="arquivoCarregandoId === arquivo.perguntaEvidenciaId"
              :disabled="!!arquivoCarregandoId" @click="verArquivo(arquivo)">Ver arquivo</v-btn>
          </div>
        </div>
      </v-card-text>
      <v-card-text v-else-if="dados" class="criterio5-conteudo">
        <v-alert v-if="!podeVerAnalise" type="info" dense outlined class="mt-4">
          Consulte os dados da equipe e os arquivos enviados. A avaliação está disponível apenas aos responsáveis pela análise.
        </v-alert>
        <v-alert v-else-if="dados.estado !== 'finalizada'" type="info" dense outlined class="mt-4">
          Avalie cada atendente e cada declaração apresentada. Um PDF pode comprovar cursos de vários atendentes.
          Salve o checklist antes de sair. Só use o botão FINALIZAR AVALIAÇÃO depois de realizar todas as avaliações necessárias.
        </v-alert>
        <v-alert v-else type="success" dense outlined class="mt-4">
          Análise finalizada. Os checklists estão disponíveis para consulta, sem edição.
        </v-alert>
        <div v-if="podeVerAnalise" class="d-flex flex-wrap align-center mb-3">
          <strong>Equipe considerada no cálculo:</strong>
          <span class="ml-2">{{ quantidadeEsperada }} atendente(s) {{ declaracaoAprovada ? 'conforme declaração aprovada' : 'conforme inscrição' }}</span>
          <v-spacer />
          <v-chip small :color="dados.estado === 'finalizada' ? 'success' : 'warning'" dark>
            {{ dados.estado === 'finalizada' ? 'Análise finalizada' : 'Em análise' }}
          </v-chip>
        </div>
        <div class="criterio5-dados-equipe mb-4">
          <strong>Dados da equipe informados na inscrição</strong>
          <div class="criterio5-dados-resumo mt-2">
            <span><strong>Na inscrição:</strong> {{ dados.quantidadeInscricao || 'não informada' }} atendente(s)</span>
            <span><strong>Quantidade atual informada:</strong> {{ dados.quantidadeAtual || 'não informada' }} atendente(s)</span>
          </div>
          <div class="criterio5-nomes mt-2"><strong>Nomes informados na inscrição:</strong>
            <span>{{ dados.nomesInscricao || 'não informados' }}</span>
          </div>
        </div>
        <v-alert v-if="!declaracoes.length" type="info" dense outlined>
          Não foi enviada declaração de alteração de equipe.
        </v-alert>

        <section v-if="declaracoes.length" class="mb-5">
          <h3 class="criterio5-subtitulo">Declaração de alteração da equipe</h3>
          <div v-for="arquivo in declaracoes" :key="arquivo.perguntaEvidenciaId" class="criterio5-arquivo">
            <div class="criterio5-linha">
              <span class="criterio5-nome">{{ arquivo.nomeArquivo }}</span>
              <v-chip v-if="arquivosDesconformes && podeVerAnalise" small color="error" outlined>Em desconformidade</v-chip>
              <v-btn small text color="primary" :loading="arquivoCarregandoId === arquivo.perguntaEvidenciaId"
                :disabled="!!arquivoCarregandoId" @click="verArquivo(arquivo)">Ver arquivo</v-btn>
              <span v-if="arquivoCarregandoId === arquivo.perguntaEvidenciaId" class="caption">Carregando arquivo...</span>
              <v-btn v-if="podeVerAnalise" small outlined color="primary" @click="abrirDeclaracao(arquivo)">Checklist da declaração</v-btn>
            </div>
            <div v-if="podeVerAnalise && arquivoAtivo === arquivo.perguntaEvidenciaId && modo === 'declaracao'" class="criterio5-checklist">
              <div v-for="item in itensDeclaracao" :key="item.key" class="criterio5-requisito">
                <span>{{ item.label }}</span>
                <v-radio-group v-model="declaracaoAtiva[item.key]" row hide-details :disabled="somenteLeitura">
                  <v-radio label="Cumprido" :value="true" /><v-radio label="Não cumprido" :value="false" />
                </v-radio-group>
              </div>
              <v-radio-group v-model="declaracaoAtiva.resultado" row label="Resultado final deste arquivo" :disabled="somenteLeitura">
                <v-radio label="Aprovar" value="aprovar" /><v-radio label="Rejeitar" value="rejeitar" />
              </v-radio-group>
              <v-textarea v-if="declaracaoAtiva.resultado === 'rejeitar'" v-model="declaracaoAtiva.justificativa"
                label="Justificativa obrigatória da rejeição" rows="2" outlined :disabled="somenteLeitura" />
              <v-btn v-if="!somenteLeitura" color="primary" @click="salvar">Salvar checklist</v-btn>
              <v-btn text color="primary" @click="ocultarChecklist">Ocultar checklist</v-btn>
            </div>
          </div>
        </section>

        <section>
          <h3 class="criterio5-subtitulo">Certificados de capacitação</h3>
          <div v-for="arquivo in certificados" :key="arquivo.perguntaEvidenciaId" class="criterio5-arquivo">
            <div class="criterio5-linha">
              <span class="criterio5-nome">{{ arquivo.nomeArquivo }}</span>
              <v-chip v-if="arquivosDesconformes && podeVerAnalise" small color="error" outlined>Em desconformidade</v-chip>
              <v-chip v-for="a in atendentesDoArquivo(arquivo.perguntaEvidenciaId)" :key="a.chave" small class="mr-1">
                {{ a.nome || 'Nome pendente' }}
                <v-btn v-if="!somenteLeitura" icon x-small class="ml-1"
                  :aria-label="`Remover ${a.nome || 'atendente sem nome'} deste arquivo`"
                  @click.stop="desvincularAtendente(arquivo.perguntaEvidenciaId, a.chave)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-chip>
              <v-btn small text color="primary" :loading="arquivoCarregandoId === arquivo.perguntaEvidenciaId"
                :disabled="!!arquivoCarregandoId" @click="verArquivo(arquivo)">Ver arquivo</v-btn>
              <span v-if="arquivoCarregandoId === arquivo.perguntaEvidenciaId" class="caption">Carregando arquivo...</span>
              <v-btn v-if="podeVerAnalise" small outlined color="primary" @click="abrirCertificado(arquivo)">Abrir checklist</v-btn>
            </div>
            <div v-if="podeVerAnalise && arquivoAtivo === arquivo.perguntaEvidenciaId && modo === 'certificado'" class="criterio5-checklist">
              <div class="d-flex flex-wrap align-center mb-2">
                <v-btn v-if="!somenteLeitura" text color="primary" class="mr-3 mb-2" @click="adicionarAtendente(arquivo.perguntaEvidenciaId)">
                  <v-icon left>mdi-account-plus</v-icon>Adicionar atendente
                </v-btn>
                <v-select v-model="atendenteAtivo" :items="opcoesAtendentes(arquivo.perguntaEvidenciaId)"
                  item-text="text" item-value="value"
                  :label="rascunho.atendentes.length ? 'Atendente neste arquivo' : 'CADASTRE UM ATENDENTE'"
                  no-data-text="CADASTRE UM ATENDENTE" dense outlined hide-details
                  class="criterio5-seletor" @change="vincularAtendente" />
              </div>
              <v-divider class="mb-4" />
              <div v-if="atendenteSelecionado">
                <v-text-field v-model="atendenteSelecionado.nome" label="Nome do atendente avaliado" outlined dense
                  :disabled="somenteLeitura" />
                <div v-for="item in itensAtendente" :key="item.key" class="criterio5-requisito">
                  <span>{{ item.label }}</span>
                  <v-radio-group v-model="atendenteSelecionado.itens[item.key]" row hide-details :disabled="somenteLeitura">
                    <v-radio label="Cumprido" :value="true" /><v-radio label="Não cumprido" :value="false" />
                  </v-radio-group>
                </div>
                <v-text-field v-model.number="atendenteSelecionado.horasValidas" type="number" min="0" step="1"
                  label="Carga horária válida devidamente computada" suffix="horas" outlined dense
                  :disabled="somenteLeitura" hide-details class="mt-4" />
                <div class="caption mt-1 mb-3">Considere apenas capacitações válidas de 2026, limitadas a 10h por dia.</div>
                <v-textarea v-model="atendenteSelecionado.observacoes" label="Observações e fundamentos sobre este atendente"
                  rows="2" outlined :disabled="somenteLeitura" />
                <v-btn v-if="!somenteLeitura" color="primary" @click="salvar">Salvar checklist</v-btn>
              </div>
              <v-alert v-else type="warning" dense outlined class="mt-2">Adicione ou selecione um atendente deste arquivo.</v-alert>
              <v-btn text color="primary" @click="ocultarChecklist">Ocultar checklist</v-btn>
            </div>
          </div>
        </section>
        <section v-if="podeVerAnalise" class="mt-5" aria-label="Conferência geral das evidências">
          <h3 class="criterio5-subtitulo">Conferência geral das evidências</h3>
          <div v-for="item in itensConferencia" :key="item.key" class="criterio5-requisito">
            <span>{{ item.label }} <strong v-if="!somenteLeitura">*</strong></span>
            <v-radio-group v-model="rascunho[item.key]" row hide-details :disabled="somenteLeitura">
              <v-radio label="Sim" :value="true" /><v-radio label="Não" :value="false" />
            </v-radio-group>
          </div>
          <div class="caption mt-2">As três respostas são obrigatórias para finalizar. Qualquer resposta “Não” resulta em zero ponto e exige justificativa.</div>
        </section>
        <v-alert v-if="arquivosDesconformes && podeVerAnalise" type="error" outlined dense class="mt-4">
          Todos os arquivos serão registrados em desconformidade com o regulamento e a nota do critério será zero. Informe a justificativa abaixo.
        </v-alert>
        <v-textarea v-if="podeVerAnalise" ref="observacoesCriterio" v-model="rascunho.observacoesCriterio"
          :label="arquivosDesconformes ? 'Justificativa obrigatória da desconformidade com o regulamento' : 'Observações e fundamentos para todo o critério'"
          rows="3" outlined :disabled="somenteLeitura" :required="conferenciaDivergente"
          :hint="conferenciaDivergente ? 'Preenchimento obrigatório: descreva a divergência identificada.' : ''"
          :persistent-hint="conferenciaDivergente" class="mt-5" />
        <v-alert v-if="dados.estado === 'finalizada'" type="success" outlined>
          {{ dados.resumoFinal }}
        </v-alert>
      </v-card-text>
      <v-card-text v-else class="pa-8 text-center"><v-progress-circular indeterminate color="primary" /></v-card-text>
      <v-divider />
      <v-card-actions class="criterio5-acoes">
        <v-btn text @click="fechar">Voltar à análise de evidências</v-btn>
        <v-spacer />
        <v-btn v-if="dados && !somenteLeitura" text color="primary" :loading="ocupado" @click="salvar">Salvar rascunho</v-btn>
        <v-btn v-if="dados && !somenteLeitura" color="azulclarosc" dark :loading="ocupado" @click="finalizar">Finalizar avaliação</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
import { evidenceQuestionAPI } from "@/modules/evidence/API/EvidenceQuestionAPI";
import { criterio5API } from "./criterio5API";

const criarRascunho = () => ({ declaracoes: [], atendentes: [], equipeConfere: null, ano2026Confere: null, arquivosConformesRegulamento: null, observacoesCriterio: "" });
const itens = [
  { key: "quatroCursos", label: "Mínimo de 4 cursos distintos" },
  { key: "gestoresMunicipais", label: "Curso obrigatório Contrata Mais Brasil – Gestores Municipais" },
  { key: "mei", label: "Curso obrigatório Contrata Mais Brasil – MEI" },
  { key: "inclusao2h", label: "Temática: Inclusão socioprodutiva – mínimo 2h" },
  { key: "comportamentais4h", label: "Temática: Competências comportamentais – mínimo 4h" },
  { key: "reforma1h", label: "Temática: Reforma Tributária – mínimo 1h" },
  { key: "horas30", label: "Mínimo de 30h de capacitação válida" },
  { key: "documentosValidos", label: "Documentação comprobatória válida" },
  { key: "horasComputadas", label: "Horas devidamente computadas" },
];

export default {
  name: "ModalCriterio5",
  props: { value: Boolean, pergunta: Object },
  data: () => ({
    dados: null, rascunho: criarRascunho(), arquivoAtivo: null, atendenteAtivo: null,
    modo: "", ocupado: false, arquivoCarregandoId: null, itensAtendente: itens,
    itensConferencia: [
      { key: "equipeConfere", label: "A(s) evidência(s) enviada(s) condizem com a quantidade e nomes de atendentes informadas na inscrição ou declaração?" },
      { key: "ano2026Confere", label: "Os certificados das horas válidas informadas para todos os atendentes correspondem ao ano de 2026?" },
      { key: "arquivosConformesRegulamento", label: "Todos os arquivos foram enviados conforme os padrões previstos no regulamento?" },
    ],
    itensDeclaracao: [
      { key: "assinada", label: "Devidamente assinada?" },
      { key: "modeloAdequado", label: "Modelo adequado?" },
    ],
  }),
  watch: {
    value(aberto) { if (aberto && this.pergunta) this.carregar(); },
    "rascunho.arquivosConformesRegulamento"(conforme) {
      if (conforme === false && !this.somenteLeitura) this.$nextTick(() => {
        const campo = this.$refs.observacoesCriterio;
        if (campo) { campo.focus(); campo.$el.scrollIntoView({ behavior: "smooth", block: "center" }); }
      });
    },
  },
  computed: {
    declaracoes() { return this.dados ? this.dados.arquivos.filter(a => a.declaracao) : []; },
    certificados() { return this.dados ? this.dados.arquivos.filter(a => !a.declaracao) : []; },
    somenteLeitura() { return !this.dados || !this.dados.podeEditar; },
    podeVerAnalise() { return !!this.dados && this.dados.podeVerAnalise === true; },
    arquivosDesconformes() { return this.rascunho.arquivosConformesRegulamento === false; },
    conferenciaDivergente() { return this.rascunho.equipeConfere === false || this.rascunho.ano2026Confere === false || this.arquivosDesconformes; },
    declaracaoAtiva() { return this.rascunho.declaracoes.find(d => d.arquivoId === this.arquivoAtivo) || {}; },
    atendenteSelecionado() { return this.rascunho.atendentes.find(a => a.chave === this.atendenteAtivo); },
    declaracaoAprovada() { return this.rascunho.declaracoes.some(d => d.resultado === "aprovar"); },
    quantidadeEsperada() { return this.declaracaoAprovada ? this.dados.quantidadeAtual : this.dados.quantidadeInscricao; },
  },
  methods: {
    erro(e) { return (e.response && e.response.data && (typeof e.response.data === "string" ? e.response.data : e.response.data.title)) || "Não foi possível concluir a operação."; },
    async carregar() {
      this.dados = null; this.arquivoAtivo = null; this.atendenteAtivo = null;
      try {
        const { data } = await criterio5API.obter(this.pergunta.perguntaMunicipioId);
        this.dados = data;
        this.rascunho = { ...criarRascunho(), ...(data.rascunho || {}) };
        this.rascunho.declaracoes = this.rascunho.declaracoes || [];
        this.rascunho.atendentes = this.rascunho.atendentes || [];
        data.arquivos.filter(a => a.declaracao).forEach(a => {
          if (!this.rascunho.declaracoes.some(d => d.arquivoId === a.perguntaEvidenciaId))
            this.rascunho.declaracoes.push({ arquivoId: a.perguntaEvidenciaId,
              assinada: null, modeloAdequado: null, resultado: null, justificativa: "" });
        });
      } catch (e) { this.$notification.error(this.erro(e)); this.fechar(); }
    },
    fechar() { if (!this.ocupado) this.$emit("input", false); },
    ocultarChecklist() { this.modo = ""; this.arquivoAtivo = null; this.atendenteAtivo = null; },
    abrirDeclaracao(arquivo) { this.modo = "declaracao"; this.arquivoAtivo = arquivo.perguntaEvidenciaId; this.atendenteAtivo = null; },
    abrirCertificado(arquivo) {
      this.modo = "certificado"; this.arquivoAtivo = arquivo.perguntaEvidenciaId;
      const existentes = this.atendentesDoArquivo(arquivo.perguntaEvidenciaId);
      this.atendenteAtivo = existentes.length ? existentes[0].chave : null;
    },
    atendentesDoArquivo(id) { return this.rascunho.atendentes.filter(a => (a.arquivoIds || []).includes(id)); },
    opcoesAtendentes(id) { return this.rascunho.atendentes.map(a => ({
      text: `${a.nome || "Atendente sem nome"}${a.arquivoIds.includes(id) ? "" : " · vincular a este PDF"}`,
      value: a.chave,
    })); },
    vincularAtendente(chave) {
      if (this.somenteLeitura) return;
      const a = this.rascunho.atendentes.find(item => item.chave === chave);
      if (a && !a.arquivoIds.includes(this.arquivoAtivo)) a.arquivoIds.push(this.arquivoAtivo);
    },
    async desvincularAtendente(arquivoId, chave) {
      if (this.somenteLeitura) return;
      const a = this.rascunho.atendentes.find(item => item.chave === chave);
      if (!a || !a.arquivoIds.includes(arquivoId)) return;
      if (a.arquivoIds.length === 1) {
        const resposta = await Swal.fire({
          title: "Remover atendente deste arquivo?",
          text: "Este é o único arquivo vinculado ao atendente. O checklist dele também será excluído.",
          icon: "warning", showCancelButton: true, confirmButtonText: "Remover atendente",
          cancelButtonText: "Cancelar", confirmButtonColor: "#2d6189",
        });
        if (!resposta.isConfirmed) return;
        this.rascunho.atendentes = this.rascunho.atendentes.filter(item => item.chave !== chave);
      } else {
        a.arquivoIds = a.arquivoIds.filter(id => id !== arquivoId);
      }
      if (this.arquivoAtivo === arquivoId && this.atendenteAtivo === chave) {
        const restantes = this.atendentesDoArquivo(arquivoId);
        this.atendenteAtivo = restantes.length ? restantes[0].chave : null;
      }
    },
    adicionarAtendente(id) {
      const chave = `at-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const respostas = {}; itens.forEach(item => { respostas[item.key] = null; });
      this.rascunho.atendentes.push({ chave, nome: "", arquivoIds: [id], itens: respostas,
        horasValidas: null, observacoes: "" });
      this.atendenteAtivo = chave;
    },
    async verArquivo(arquivo) {
      if (this.arquivoCarregandoId) return;
      this.arquivoCarregandoId = arquivo.perguntaEvidenciaId;
      try {
        const resp = await evidenceQuestionAPI.download(arquivo.perguntaEvidenciaId);
        const tipo = resp.headers["content-type"] || "application/pdf";
        if (tipo.includes("application/json")) {
          const payload = JSON.parse(await resp.data.text());
          if (payload.url) { window.open(payload.url, "_blank"); return; }
        }
        const url = URL.createObjectURL(new Blob([resp.data], { type: tipo }));
        window.open(url, "_blank");
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (e) { this.$notification.error("Não foi possível abrir o arquivo."); }
      finally { this.arquivoCarregandoId = null; }
    },
    async salvar() {
      if (this.somenteLeitura) return;
      this.ocupado = true;
      try {
        await criterio5API.salvar(this.pergunta.perguntaMunicipioId, this.rascunho);
        this.$notification.success("Checklist salvo.");
      } catch (e) { this.$notification.error(this.erro(e)); }
      finally { this.ocupado = false; }
    },
    async finalizar() {
      if (this.somenteLeitura) return;
      if (this.itensConferencia.some(item => typeof this.rascunho[item.key] !== "boolean")) {
        await Swal.fire({ title: "Conferência obrigatória", text: "Responda às três perguntas de conferência geral das evidências antes de finalizar.",
          icon: "error", confirmButtonText: "Voltar à conferência", confirmButtonColor: "#2d6189" });
        return;
      }
      if (this.conferenciaDivergente && !String(this.rascunho.observacoesCriterio || "").trim()) {
        await Swal.fire({ title: "Justificativa obrigatória", text: "Foi sinalizada uma divergência na conferência geral das evidências. Preencha a justificativa antes de finalizar.",
          icon: "error", confirmButtonText: "Voltar às observações", confirmButtonColor: "#2d6189" });
        return;
      }
      const arquivoSemAtendente = this.certificados.find(arquivo =>
        !this.atendentesDoArquivo(arquivo.perguntaEvidenciaId).length);
      if (arquivoSemAtendente && !this.arquivosDesconformes) {
        await Swal.fire({
          title: "Arquivo sem atendente",
          text: `Vincule pelo menos um atendente ao arquivo "${arquivoSemAtendente.nomeArquivo}" antes de finalizar.`,
          icon: "warning", confirmButtonText: "Voltar ao checklist", confirmButtonColor: "#2d6189",
        });
        return;
      }
      this.ocupado = true;
      try {
        const id = this.pergunta.perguntaMunicipioId;
        const { data } = await criterio5API.previa(id, this.rascunho);
        this.ocupado = false;
        const naoCumpridos = data.naoCumpridos && data.naoCumpridos.length
          ? `<ul class="criterio5-previa-pendencias">${data.naoCumpridos.map(item => `<li>${this.escaparHtml(item)}</li>`).join("")}</ul>`
          : "<p>Todos os requisitos obrigatórios foram cumpridos.</p>";
        const pontuacao = Number(data.pontos).toFixed(1).replace(".", ",");
        const observacoes = data.observacoes && data.observacoes.length
          ? `<div><strong>OBSERVAÇÕES E FUNDAMENTOS:</strong><ul class="criterio5-previa-pendencias">${data.observacoes.map(item => `<li>${this.escaparHtml(item)}</li>`).join("")}</ul></div>`
          : "";
        const avisoZero = Number(data.pontos) === 0
          ? `<p class="criterio5-previa-zero"><strong>PONTUAÇÃO NÃO ALCANÇADA: ${pontuacao}</strong><br>
              A pontuação máxima ou proporcional será concedida apenas se 100% da equipe estiver capacitada
              e todos os atendentes cumprirem todos os itens obrigatórios.</p>`
          : `<p><strong>PONTUAÇÃO CALCULADA:</strong> ${pontuacao}</p>`;
        const resposta = await Swal.fire({
          title: "Confirme a avaliação do Critério 05",
          html: `<div class="criterio5-previa">
            ${avisoZero}
            <p><strong>MENOR CARGA VÁLIDA:</strong> ${Number(data.menorCargaHoraria)}h</p>
            <div><strong>NÃO CUMPRIDOS:</strong>${naoCumpridos}</div>
            ${observacoes}
            <p class="criterio5-previa-confirmacao">CONFIRMA A FINALIZAÇÃO? AVALIAÇÕES FINALIZADAS NÃO PODEM SER ALTERADAS.</p>
          </div>`,
          icon: "question", showCancelButton: true, confirmButtonText: "Confirmar avaliação",
          cancelButtonText: "Voltar ao checklist", confirmButtonColor: "#2d6189", width: "min(760px, calc(100vw - 24px))",
        });
        if (!resposta.isConfirmed) return;
        this.ocupado = true;
        await criterio5API.finalizar(id, this.rascunho);
        this.$notification.success("Avaliação finalizada e pontuação gravada.");
        this.$emit("finalizada");
        this.$emit("input", false);
      } catch (e) { this.$notification.error(this.erro(e)); }
      finally { this.ocupado = false; }
    },
    escaparHtml(valor) { return String(valor).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])); },
  },
};
</script>

<style scoped>
.criterio5-conteudo { max-height: 78vh; overflow-y: auto; }
.criterio5-dados-equipe { border: 1px solid #dce4e8; border-radius: 8px; background: #f8fafc; padding: 10px 14px; }
.criterio5-dados-resumo { display: flex; flex-wrap: wrap; gap: 8px 24px; }
.criterio5-nomes span { display: block; white-space: pre-line; overflow-wrap: anywhere; }
.criterio5-subtitulo { color: #234e6f; font-size: 17px; margin: 18px 0 10px; }
.criterio5-arquivo { border: 1px solid #dce4e8; border-radius: 8px; margin-bottom: 10px; }
.criterio5-linha { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; padding: 10px 14px; }
.criterio5-nome { font-weight: 600; min-width: 210px; flex: 1; overflow-wrap: anywhere; }
.criterio5-checklist { border-top: 1px solid #dce4e8; background: #f8fafc; padding: 18px; }
.criterio5-requisito { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e4e9ed; min-height: 48px; gap: 14px; }
.criterio5-requisito span { max-width: 58%; }
.criterio5-seletor { max-width: 440px; min-width: 220px; }
@media(max-width:700px) {
  .criterio5-conteudo { max-height: calc(100vh - 235px); }
  .criterio5-requisito { flex-direction: column; align-items: flex-start; padding: 8px 0; }
  .criterio5-requisito span { max-width: 100%; }
  .criterio5-acoes { flex-wrap: wrap; gap: 4px; padding: 8px 12px; }
  .criterio5-acoes .spacer { display: none; }
  .criterio5-acoes .v-btn { flex: 1 1 100%; min-width: 0 !important; margin: 0 !important; }
}
</style>

<style>
.criterio5-previa { text-align: left; font-size: 16px; line-height: 1.5; }
.criterio5-previa p { margin-bottom: 10px; }
.criterio5-previa-zero { padding: 10px 12px; border-radius: 6px; background: #fff4e5; color: #66451d; }
.criterio5-previa-pendencias { max-height: 180px; overflow-y: auto; padding-left: 24px; margin: 8px 0 16px; }
.criterio5-previa-pendencias li { white-space: pre-wrap; overflow-wrap: anywhere; }
.criterio5-previa-confirmacao { margin-top: 18px; font-weight: 600; }
</style>
